(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.ll-draw, .ll-guide__step, .multicolumn-list__item, .ll-page-intro__mark, .ll-photo-tab, .ll-product-details, .blog-articles__article, .ll-faq__intro, .collection__view-all, .ll-trust__item';
  let observer;
  let observed = new WeakSet();

  const getTargets = (root) => {
    const targets = Array.from(root.querySelectorAll(selector));
    if (root instanceof Element && root.matches(selector)) targets.unshift(root);
    return targets;
  };

  const animateVisible = (root = document) => {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver((entries) => {
      if (reducedMotion.matches) return;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(entry.target.matches('.ll-draw') ? 'll-draw--visible' : 'll-reveal');
        observer?.unobserve(entry.target);
      }
    }, { threshold: .12 });
    for (const target of getTargets(root)) {
      const isDrawing = target.matches('.ll-draw');
      if (observed.has(target) || target.classList.contains(isDrawing ? 'll-draw--visible' : 'll-reveal')) continue;
      if (!isDrawing && target.closest('.scroll-trigger')) continue;
      if (isDrawing) target.classList.add('ll-draw--armed');
      observed.add(target);
      observer.observe(target);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => animateVisible(), { once: true });
  else animateVisible();
  document.addEventListener('shopify:section:load', (event) => animateVisible(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (observer) getTargets(event.target).forEach((target) => observer.unobserve(target));
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      if (observer) observer.disconnect();
      observer = undefined;
      observed = new WeakSet();
      document.querySelectorAll('.ll-draw--armed').forEach((target) => target.classList.remove('ll-draw--armed'));
    } else animateVisible();
  });
})();
